import { createRoot } from 'react-dom/client';
import config from './config';
import { initAnalytics } from '~/components/analytics';
import App from '~/components/App';

const container = document.getElementById('root');
const root = createRoot(container);

const prepare = async () => {
  // Initialize analytics
  initAnalytics();

  // Setup MSW mock server in test environments
  if (config.ENABLE_MSW === 'true') {
    try {
      const promisedWorker = await import('../mocks/browser');
      const worker = await promisedWorker.worker;
      // @ts-expect-error 'msw' does not exist on type 'Window & typeof globalThis'
      window.msw = worker;
      await worker?.start({ onUnhandledRequest: 'bypass' });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to start MSW:', error);
    }
  }
};

prepare()
  .then(() => {
    root.render(<App />);
  })
  .catch(error => {
    // eslint-disable-next-line no-console
    console.error('Failed to initialize app:', error);
    root.render(<App />); // Still render the app even if initialization fails
  });
